// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Rectangle.View'
    , [
        'calculator_square_foot_rectangle.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_rectangle_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_rectangle_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-rectangle"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var width = $('#square-foot-rectangle-width').val(),
                    length = $('#square-foot-rectangle-length').val();
                //output fields
                var area = $('#square-foot-rectangle-area');

                var result = parseFloat(width) * parseFloat(length);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-rectangle-input-fields').find('input:text').val('');
                $('.calculator-square-foot-rectangle-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
